var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"50vh"}},[(_vm.chartData?.datasets?.length > 0)?_c('LineChartGenerator',{staticStyle:{"height":"100%"},attrs:{"chart-options":_vm.computed_chart_options,"chart-data":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }